export const appSettings = {
  shouldShowConsentDialog: false,
}
